import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=b22a6c38&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b22a6c38')) {
      api.createRecord('b22a6c38', component.options)
    } else {
      api.reload('b22a6c38', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=b22a6c38&", function () {
      api.rerender('b22a6c38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2JXS1dNWuNGbn/JS/pricehelp.vue"
export default component.exports